import { RootState } from '../index';

const getTokenDetails = (state: RootState) => state.authReducer.tokenDetails;
const getAuthenticateUser = (state: RootState) => state.authReducer.authenticateUser;

export {
  getTokenDetails,
  getAuthenticateUser,
};
